<!-- 不推荐达人 -->
<template>
  <div class="not-Recommended">
    <div class="page">
      <div class="title">{{ titleText }}</div>
      <div class="flex-box search-box">
        <button class="btn" @click="addFn">+ 新增</button>
        <div>
          <vxe-input v-model="key" placeholder="请输入" style="width: 200px;margin-right: 10px;"></vxe-input>
          <button class="btn" @click="getList">搜索</button>
        </div>
      </div>
      <vxe-table
        v-fixed-table-header
        ref="tableRef"
        border="inner"
        align="center"
        :loading = "loading"
        :data="tableData"
        >
        <vxe-column
          v-for="(item, index) in finalColumns"
          :key="item.field + index"
          :field="item.field"
          :fixed="item.fixed || ''"
          :title="item.title"
          :min-width="item.width || 140"
          >
        </vxe-column>
        <vxe-column title="操作" fixed="right" width="190">
          <template #default="scope">
            <div style="display: flex;justify-content: space-around;">
              
              <vxe-button type="text" status="primary" content="编辑" @click="editFn(scope.row)"></vxe-button>
              <vxe-button type="text" status="primary" content="删除" @click="del(scope.row)"></vxe-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        background
        :align="'right'"
        class="my-list-pager"
        @page-change="pageChange"
        :current-page.sync="pager.page"
        :page-size.sync="pager.limit"
        :page-sizes="[15, 30, 50]"
        :total="pager.total"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      </vxe-pager>
     
      <vxe-modal v-model="edit.show" :title="edit.type=='add'? addText : editText" width="800" className="custom-modal" show-footer destroy-on-close >
        <template #default>
          <vxe-form ref="vxeForm" :data="form" prevent-submit custom-layout>
            <vxe-form-item title="达人账号" field="lid">
              <el-select clearable remote filterable collapse-tags placeholder="请选择" size="small"
                :remote-method="e=>{search(e)}" :loading="remoteMethodLoading"
                v-model="form.lid" :disabled="edit.type=='edit'">
                <el-option v-for="item in options" :key="item.value" :label="'['+item.platform+']'+item.nickname+'('+item.shortid+')'" :value="item.id">
                </el-option>
              </el-select>
            </vxe-form-item>
            <vxe-form-item :title="formText" field="reason">
              <vxe-input v-model="form.reason" placeholder="请输入"></vxe-input>
            </vxe-form-item>
          </vxe-form>
        </template>
        <template #footer>
            <vxe-button size="mini" @click="edit.show = false">取消</vxe-button>
            <vxe-button size="mini" status="primary" @click="onEditConfirm">确定</vxe-button>
        </template>
    </vxe-modal>
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      remoteMethodLoading:false,
      key:'',
      columns: [
          { title: '达人昵称', field: 'nick_name', disabled:false, width: 160, sortable: false, fixed: '',},
          { title: '平台', field: 'plat', disabled:false, width: 140, sortable: false, fixed: '',},
          { title: 'UID', field: 'short_id', disabled:false, width: 160, sortable: true, fixed: '',},
          { title: '账号ID', field: 'unique_id',disabled:false, width: 160, sortable: false, fixed: ''},
          { title: '账号类型', field: 'logings',disabled:false,  width: 120, sortable: true, fixed: ''},
          { title: '不推荐理由', field: 'reason',disabled:false, width: 120, sortable: false, fixed: ''},
          { title: '加入不推荐达人时间', field: 'adddt',disabled:false,  width: 160, sortable: true, fixed: ''},
          { title: '添加人', field: 'uname',disabled:false,  width: 120, sortable: true, fixed: ''},
          { title: '最近一次编辑时间', field: 'optdt',disabled:false,  width: 160, sortable: true, fixed: ''},
        ],
      columns1: [
          { title: '达人昵称', field: 'nick_name', disabled:false, width: 160, sortable: false, fixed: '',},
          { title: '平台', field: 'plat', disabled:false, width: 140, sortable: false, fixed: '',},
          { title: 'UID', field: 'short_id', disabled:false, width: 160, sortable: true, fixed: '',},
          { title: '账号ID', field: 'unique_id',disabled:false, width: 160, sortable: false, fixed: ''},
          { title: '账号类型', field: 'logings',disabled:false,  width: 120, sortable: true, fixed: ''},
          { title: '强推备注', field: 'reason',disabled:false, width: 120, sortable: false, fixed: ''},
          { title: '添加时间', field: 'adddt',disabled:false,  width: 160, sortable: true, fixed: ''},
          { title: '添加人', field: 'uname',disabled:false,  width: 120, sortable: true, fixed: ''},
          { title: '最近一次编辑时间', field: 'optdt',disabled:false,  width: 160, sortable: true, fixed: ''},
        ],
        pager: {
          page: 1,
          limit: 30,
          total: 0
        },
        loading:false,
        tableData:[],
        form:{
          lid:'',
          reason:'',
        },
        key:'',
        edit:{
          type:'add',
          show:false,
          form:{},
        },
        options:[],
        rowId:'',
    };
  },
  components:{
  },
  computed: {
    api(){
      if(this.$route.query.rec == 1){
        return "recList"
      }else{
        return "banList"
      }
    },
    titleText(){
      if(this.$route.query.rec == 1){
        return "强推达人"
      }else{
        return "不推荐达人"
      }
    },
    finalColumns(){
      if(this.$route.query.rec == 1){
        return this.columns1
      }else{
        return this.columns
      }
    },
    addText(){
      if(this.$route.query.rec == 1){
        return "新增强推达人"
      }else{
        return "新增不推荐达人"
      }
    },
    editText(){
      if(this.$route.query.rec == 1){
        return "编辑强推达人"
      }else{
        return "编辑不推荐达人"
      }
    },
    formText(){
      if(this.$route.query.rec == 1){
        return "强推备注"
      }else{
        return "不推荐理由"
      }

    }
    
  },
  watch: {
    'pager.page'(){
      this.getList()
    },
    'pager.limit'(){
      this.getList()
    },
  },
  created() {
    this.getList()
    this.search()
  },
  methods: {

    editInit(row){
      console.log('初始化 :>> ',row);
      let params={
        id:row.id
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=detail`,{ params,headers: { showLoading: false },}).then(res=>{
        console.log('res123 :>> ', res);
        this.form.reason = res.reason
        this.form.lid = res.mid
        }
      ).catch( err => console.log('err :>> ', err))
    },
    search(e){
      this.remoteMethodLoading = true
      let params={
        key:e,
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=search`,{params,headers: { showLoading: false },}).then(res=>{
        this.remoteMethodLoading = false
        this.options = res
        }
      ).catch( err => console.log('err :>> ', err))
    },
    add(){
      if(this.form.lid == ''){
        this.$message.error('请选择达人账号');
        return
      }
      if(this.form.reason == ''){
        this.$message.error(`请选择${this.formText}`);
        return
      }
      let params={
        lid:this.form.lid,
        reason:this.form.reason
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=add`,{params,headers: { showLoading: false },}).then(res=>{
        this.$message.success('添加成功'); 
        this.getList()   
        this.edit.show = false
        }
      ).catch( err => {
        console.log('err :>> ', err)
        this.edit.show = false
      })
    },
    addFn(){
      this.edit.show = true; 
      this.edit.type = 'add';
      this.form.lid = ''
      this.form.reason = ''
    },
    editFn(row){
      this.edit.show = true;
      this.edit.type = 'edit';
      this.rowId = row.id
      this.editInit(row)
    },
    editConfirm(id){
      let params={
        id,
        reason:this.form.reason
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=banEdit`,{params,headers: { showLoading: false },}).then(res=>{
        this.$message.success('编辑成功');
        this.getList()  
        this.edit.show = false
        }
        ).catch( err => {
        console.log('err :>> ', err)
        this.edit.show = false
      })
    },
    del(row){
      let params={
        id:row.id
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=delete`,{params,headers: { showLoading: false },}).then(res=>{
        this.$message.success('删除成功');
        this.getList();  
        console.log('res :>> ', res);
        }
      ).catch( err => console.log('err :>> ', err))
    },
    getList(){
      this.loading = true
      let params={
        key:this.key
      }
      this.$axios.get(`api.php?m=${this.api}|api|gx&a=list`,{ params, headers: { showLoading: false },}).then(res=>{
        const {list,pageinfo} = res
        this.loading = false
        this.tableData = list
        this.pager.total = pageinfo.total
        }
      ).catch( err => console.log('err :>> ', err))
    },
    pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pager.page = 1
        }
        this.getList()
      },
    onEditConfirm() {
      if(this.edit.type=='add'){
        this.add()
      }else{
        this.editConfirm(this.rowId)
      }
    }
  }
};
</script>
<style  lang='less'>
.not-Recommended{
  .el-tooltip.item {
    margin-top: 0px !important;
  }
  }
</style>

<style lang='less' scoped>
.not-Recommended{
  margin: 20px 0;
  .search-box{
    margin: 20px 0;
  }
  .flex-box{
    display: flex;
    justify-content: space-between;
  }
  .btn{
    padding: 8px 15px 8px 15px;
    background-color: rgba(255, 92, 0, 1);
    color: #FFFFFF;
    border-radius: 4px;
    border: none;
  }
  .page{
    margin: 0 auto;
    width: calc(100% - 100px);
    background: #fff;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 6px;
    padding: 20px;
    .title{
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>